import type { RadioGroupState } from 'react-stately'
import { createContextWithHook } from '@chilipiper/utils'

export const { RadioBaseProvider, useRadioContext } = createContextWithHook<{
  name: string
  state: RadioGroupState
}>()('Radio')
